import httpClient from 'src/common/fetch'
import { apiSignUpDTO } from './dto'

export const createApiSignupRequest = (params: apiSignUpDTO) => {
  return httpClient.post('/organizations/signup/api', params)
}
